<template>
  <div class="provider-selection-item-grid">
    <div class="selection-item-image-grid">
      <div class="provider-selection-item_map-id">
        <i v-if="selected" class="vcore_icon icon-check"></i>
        <span v-else>{{ provider.alphaID }}</span>
      </div>
      <LogoDisplay class="logo" :logo-src="logo"></LogoDisplay>
    </div>
    <div class="selection-items-grid">
      <div v-if="provider.location.locationName" class="selection-item">
        {{ provider.location.locationName }}
      </div>
      <div v-else class="selection-item">
        {{ provider.providerName }}
      </div>
      <div class="selection-item">
        {{ provider.location.address1 }}
      </div>
      <div v-if="provider.location.address2" class="selection-item">
        {{ provider.location.address2 }}
      </div>
      <div class="selection-item">
        {{ provider.location.city }}, {{ provider.location.state }}
        {{ provider.location.zipCode }}
      </div>
    </div>
    <div v-show="!selected" class="selection-item-button-grid">
      <Button
        v-if="
          (provider.enrollmentInstitutionID !== null &&
          provider.selfEnrollmentEnabled) || provider.isCommerceCare
        "
        size="large"
        color="blue"
        block
        :loading="clicked"
        :aria-label="ariaLabel"
        @click.native="handleProviderClick(provider)"
      >
        {{ buttonText }}
      </Button>
      <div v-else>
        Please contact your provider directly to enroll for HSF<span class="sup"
          >&reg;</span
        >.
      </div>
    </div>
  </div>
</template>

<script>
import Button from "@Shared/components/Button";
import LogoDisplay from "../LogoDisplay";
import { mapGetters, mapActions } from "vuex";
import { KEYS, getCustomBrandingByKey } from "@Shared/utils/CustomBranding";

export default {
  name: "ProviderSelectionItem",
  components: {
    Button,
    LogoDisplay,
  },
  props: {
    provider: {
      required: true,
    },
    selected: Boolean,
  },
  data() {
    return {
      clicked: false,
    };
  },
  computed: {
    ...mapGetters(["selectedProvider", "requestStatus"]),
    buttonText() {
      if (this.selected) {
        return "Selected";
      }
      return "Select Provider";
    },
    ariaLabel() {
      if (this.selected) {
        return "Unselect Provider";
      }
      return "Select Provider";
    },
    logo() {
      return getCustomBrandingByKey(
        KEYS.LOGO,
        this.provider.customBrandingList
      );
    },
  },
  watch: {
    "requestStatus.selectedProvider.active"(newVal, oldVal) {
      if (oldVal === true && newVal === false) {
        this.clicked = false;
      }
    },
  },
  inject: ["verticalProgressSteps"],
  methods: {
    ...mapActions(["setSelectedProviderBySpid", "resetSelectedProvider"]),

    handleProviderClick(provider) {
      if (
        Object.keys(this.selectedProvider).length === 0 &&
        this.selectedProvider.constructor === Object
      ) {
        this.clicked = true;
        this.setSelectedProviderBySpid(provider);
        this.$ga.event({
          eventCategory: "Provider Selection",
          eventAction: provider.providerName,
          eventLabel: provider.alphaID,
        });
      } else {
        this.verticalProgressSteps.pop();
        this.resetSelectedProvider();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.sup {
  font-size: 70%;
  vertical-align: super;
}

.provider-selection-item-grid {
  display: grid;
  grid-template-columns: 25% 45% 25%;
  background-color: #f7f8fa;
  border-radius: 10px;
  margin-bottom: 30px;
  margin-top: 30px;

  @media all and (max-width: $grid-breakpoint-lg) {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(3, auto);
    row-gap: 10px;
  }

  .selection-item-image-grid {
    display: flex;
    justify-content: center;
    margin: 1vw 0vw;
    flex-direction: column;

    .logo {
      display: flex;
      justify-content: center;
    }
  }

  .selection-items-grid {
    display: grid;
    grid-template-rows: repeat(4, auto);
    margin: 2vw 0vw;
    row-gap: 5px;

    @media all and (max-width: $grid-breakpoint-lg) {
      margin: 2vw 5%;
      row-gap: 15px;
    }

    .selection-item {
      font-size: 24px;
      font-weight: 700;
      font-family: "Open Sans";
    }

    .selection-pill-grid {
      display: grid;
      grid-template-columns: repeat(1, auto);
      margin-top: 1vh;

      .pill {
        display: flex;
        justify-content: center;
        background: #e5efec;
        border-radius: 500px;
        width: 45%;
        height: 34px;
        align-items: center;

        @media all and (min-width: 993px) and (max-width: 1269px) {
          width: 65%;
        }

        @media all and (max-width: $grid-breakpoint-lg) {
          width: 55%;
        }

        @media all and (max-width: $grid-breakpoint-sm) {
          width: 65%;
        }

        .pill-text {
          font-family: "Poppins";
          font-weight: 600;
          font-size: 14px;
          color: #006747;
        }
      }
    }
  }

  .selection-item-button-grid {
    display: flex;
    justify-content: center;
    margin: auto 0;

    @media all and (max-width: $grid-breakpoint-lg) {
      margin: 25px 5%;
    }
  }

  .provider-selection-item_map-id {
    position: relative;
    top: -30px;
    left: -10px;
    background-color: #006747;
    color: #ffffff;
    height: 30px;
    width: 30px;
    line-height: 30px;
    text-align: center;
    border-radius: 999px;

    @media (max-width: $grid-breakpoint-lg) {
      top: -20px;
    }

    @media (max-width: $grid-breakpoint-sm) {
      margin: 0 auto;
      left: 0;
      right: 0;
    }
  }
}
</style>
